// extracted by mini-css-extract-plugin
export default {"Loading":"preloader_Loading__bTw2h","circle":"preloader_circle__Euanz","spinner-border":"preloader_spinner-border__Epkxu","spin":"preloader_spin__AnJ1t"};